import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'


/**
 * Generates and triggers download of an Excel file containing multiple datasets.
 *
 * @param {Array} datasets - An array of objects, each with 'name' and 'data' properties.
 *                           'name' is the sheet name, 'data' is an array of JSON objects.
 * @param {string} fileName - The name of the generated Excel file.
 */
export function generateExcelFile(datasets,fileName='runbook_all_data_.xlsx') {
  const workbook = XLSX.utils.book_new()

  datasets.forEach(({ name, data }) => {
    if (!data || data.length === 0) {
      // Add a dummy sheet if no data
      const ws = XLSX.utils.aoa_to_sheet([['No data available']])
      XLSX.utils.book_append_sheet(workbook, ws, name)
    } else {
      // Convert JSON to worksheet
      const ws = XLSX.utils.json_to_sheet(data)
      XLSX.utils.book_append_sheet(workbook, ws, name)
    }
  })

  // Write to binary buffer
  const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })

  // Save file
  const blob = new Blob([wbout], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  saveAs(blob, fileName)
}
